import AceOcnPermitToTransferApiUrls from 'src/apiUrls/AceOcnPermitToTransferApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React, { useState, useEffect, useRef } from 'react'
import {
  components,
  constants,
  useServices
} from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import pathMap from 'src/paths/pathMap'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import { useHistory } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { FileForUserGetUserDetails, GetLoggedInUserPartyName } from 'src/common/FileForUserCommon'
import ChargeTypeDialog from '../../common/ChargeTypeDialog'
import ErrorMessageDialog from 'src/views/common/ErrorMessageDialog'

const {
  button: { CngButton },
  form: { CngEditForm },
  table: { useFetchCodeMaintenanceLookup }
} = components

const { filter: { EQUAL } } = constants

function EditPage(props) {
  const {
    id,
    permitToTransferData,
    onChangeStep,
    onSetLoading,
    onSetPermitToTransferStatus,
    showNotification,
    step
  } = props

  const onSuccessCallback = useRef(() => { })
  const history = useHistory()
  const { securedSendRequest } = useServices()

  const [isSuperParty, setSuperParty] = useState(false);

  const [chargeTypes, setChargeTypes] = useState([])
  const [submitDialog, setSubmitDialog] = useState({ open: false, items: [] })
  const [errorMessageDialog, setErrorMessageDialog] = useState({ open: false, errorMessages: [] })

  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

  function handleSubmitPermitToTransfer(data) {
    onSetLoading(true)
    data.id=id;
    const fileForUserDetails = FileForUserGetUserDetails()
    if (fileForUserDetails) {
      const { fileForUserId, fileForUserLoginId, fileForUserPartyId } = fileForUserDetails
      data.fileForUserId = fileForUserId
      data.fileForUserLoginId = fileForUserLoginId
      data.fileForUserPartyId = fileForUserPartyId
    }

    securedSendRequest.execute('POST', AceOcnPermitToTransferApiUrls.SUBMIT, data,
      (response) => {
        const data = response.data
        var errorMessages = []
        var errorFlag = false
       
        var obj = data
        if (obj.errorMessages != null && obj.errorMessages.length > 0) {
          errorMessages.push(obj.errorMessages)
          errorFlag = true
        }
        
        if (errorFlag) {
          setErrorMessageDialog({ open: true, errorMessages })
        } else {
          showNotification('success', 'Submitted successfully.')
          history.push(pathMap.ACE_OCN_PERMIT_TO_TRANSFER_LIST_VIEW)
        }
      },
      (error) => {
        console.error(error)
        showNotification('error', 'Failed to submit Permit to Transfer.')
      },
      () => onSetLoading(false)
    )
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CngEditForm
            fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
            showNotification={showNotification}
            renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
              <FormProperties.Fields
                disabled={false}
                showNotification={showNotification}
                shouldHideMap={shouldHideMap}
                isEditMode={true}
              />
            )}
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{
              url: AceOcnPermitToTransferApiUrls.GET,
              onPreSuccess: (serverData) => {
                permitToTransferData.current = serverData
                onSetPermitToTransferStatus(serverData.status)
              }
            }}
            update={{
              url: AceOcnPermitToTransferApiUrls.PUT,
              onPostSubmitSuccess: (e) => {
                permitToTransferData.current = e
                onSetPermitToTransferStatus(e.status)
                onSuccessCallback.current()
              }
            }}
            id={id}
            renderButtonSection={(loading) => (
              <PermitToTransferAddPageButtonSection
                history={history}
                loading={loading}
                onSetLoading={onSetLoading}
                onSubmitPermitToTransfer={handleSubmitPermitToTransfer}
              />
            )}
          />
        </Grid>
      </Grid>
      <ChargeTypeDialog
        chargeTypes={chargeTypes}
        onClose={() => setSubmitDialog({ open: false, items: [] })}
        onSubmit={handleSubmitPermitToTransfer}
        open={submitDialog.open}
        items={submitDialog.items}
      />
      <ErrorMessageDialog
        errorMessages={errorMessageDialog.errorMessages}
        open={errorMessageDialog.open}
        onClose={() => setErrorMessageDialog({ open: false })} />
    </>
  )
}

export default EditPage

function PermitToTransferAddPageButtonSection(props) {
  const { history, loading, onSetLoading, onSubmitPermitToTransfer } = props

  const [confirmDialog, setConfirmDialog] = useState(false)
  const { getValues } = useFormContext()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={loading}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <Grid container spacing={2}>
            <Grid item xs='auto'>
              <CngButton
                color='primary'
                disabled={loading}
                // onClick={onSaveOnly}
                type='submit'
                size='medium'
                shouldShowProgress={loading}
              >
                Update
              </CngButton>
              </Grid>
              <Grid item xs='auto'>
              <CngButton
                color='primary'
                disabled={loading}
                size='medium'
                onClick={() => onSubmitPermitToTransfer(FormProperties.toServerDataFormat(getValues()))}>
                  Submit
              </CngButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.ACE_OCN_PERMIT_TO_TRANSFER_LIST_VIEW)}
        content="All progress in this session will be lost and cant't be restored. Are you sure about this?"
        okMsg='Yes, discard'
        cancelMsg='Continue editing'
        title='Discard'
      />
    </>
  )
}